module.exports = __webpack_public_path__ + "img/invite-bg.6bbb97a6.png";